import { render, staticRenderFns } from "./VoteHistoryBar.vue?vue&type=template&id=1efd0a22&scoped=true&"
import script from "./VoteHistoryBar.vue?vue&type=script&lang=js&"
export * from "./VoteHistoryBar.vue?vue&type=script&lang=js&"
import style0 from "./VoteHistoryBar.vue?vue&type=style&index=0&id=1efd0a22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efd0a22",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
